import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { getApiErrorMessage } from '../../../utils/apiError';

const MedicineAdministrationModal: React.FC<any> = ({ onClose }) => {
    const [formData, setFormData] = useState({
        RA_Medical_Term: '',
        RA_Abbreviation: '',
        RA_Urdu_Term: "",
    });

    const [errors, setErrors] = useState({
        RA_Medical_Term: false,
        RA_Abbreviation: false,
        RA_Urdu_Term: false,
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (errors[name as keyof typeof errors] !== undefined) {
            setErrors(prev => ({ ...prev, [name]: false }));
        }
    };

    const handleSubmit = async () => {
        const payload = {
            RA_Medical_Term: formData.RA_Medical_Term.trim(),
            RA_Abbreviation: formData.RA_Abbreviation.trim(),
            RA_Urdu_Term: formData.RA_Urdu_Term.trim(),
        };

        const newErrors = {
            RA_Medical_Term: !payload.RA_Medical_Term,
            RA_Abbreviation: !payload.RA_Abbreviation,
            RA_Urdu_Term: !payload.RA_Urdu_Term,
        };
        
        setErrors(newErrors);
        
        if (Object.values(newErrors).some(error => error)) {
            toast.error('Please fill in all required fields');
            return;
        }

        if (loading) return;
        setLoading(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_OPD_API_URL}/routes-of-administration/addAdministrationRout`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                }
            );
            if (response.data.isSuccess === false) {
                toast.error(response.data.message || 'Failed to add route');
            } else {
                toast.success(response.data.message || 'Route added successfully');
                setFormData({
                    RA_Medical_Term: '',
                    RA_Abbreviation: '',
                    RA_Urdu_Term: '',
                });
                setErrors({
                    RA_Medical_Term: false,
                    RA_Abbreviation: false,
                    RA_Urdu_Term: false,
                });
                onClose()
            }
        } catch (error: any) {
            toast.error(getApiErrorMessage(error, 'Failed to add route'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            <Box sx={{ background: '#fff', p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <Typography variant='h5' sx={{ fontWeight: '600', fontSize: '14px' }}>Add Route Administration</Typography>
                <CancelOutlinedIcon onClick={onClose} sx={{ cursor: 'pointer' }} />
            </Box>

            <Box p={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField size="small"
                            label='Enter Abr Notation'
                            name='RA_Abbreviation'
                            value={formData.RA_Abbreviation}
                            fullWidth
                            required
                            error={errors.RA_Abbreviation}
                            onChange={handleChange}
                            className="search-field"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField size="small"
                            label='Enter Eng Notation'
                            name='RA_Medical_Term'
                            value={formData.RA_Medical_Term}
                            fullWidth
                            required
                            error={errors.RA_Medical_Term}
                            onChange={handleChange}
                            className="search-field"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            size="small"
                            label="Enter Urdu Notation"
                            name="RA_Urdu_Term"
                            value={formData.RA_Urdu_Term}
                            fullWidth
                            required
                            error={errors.RA_Urdu_Term}
                            onChange={handleChange}
                            className="search-field"
                        />
                    </Grid>
                </Grid>
                <Box display='flex' justifyContent='flex-end' mt={2}>
                    <Button variant='contained' onClick={handleSubmit} disabled={loading}>
                        {loading ? 'Saving...' : 'Save'}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default MedicineAdministrationModal;
